export const UTM_KEYS = [
  'utm_campaign',
  'utm_source',
  'utm_medium',
  'utm_term',
  'utm_content',
  'utm_adgroup',
  'utm_placement',
  'utm_device',
  'utm_audience',
  'utm_geo',
  'utm_creative',
  'utm_network',
  'utm_id',
];

export function getUtmParams(search = '') {
  const params = new URLSearchParams(search);
  const result = {};

  UTM_KEYS.forEach((key) => {
    const fromUrl = params.get(key);
    const fromSession = sessionStorage.getItem(key);
    const value = fromUrl || fromSession || '';

    if (value) {
      result[key] = value;
      sessionStorage.setItem(key, value);
    }
  });

  return result;
}

export function buildDonationUrl({ projectId, donationValue, utmParams = {} }) {
  const params = new URLSearchParams();

  params.set('donation', String(donationValue));

  UTM_KEYS.forEach((key) => {
    const value = utmParams[key];
    if (value) params.set(key, value);
  });

  return `/project/${projectId}/donation?${params.toString()}`;
}
